type BaseValueType = string | number;
type ValueType = BaseValueType | BaseValueType[];

export default function convertCssUnit(value: ValueType): ValueType {
  if (!value) {
    return value;
  }
  if (Array.isArray(value)) {
    // TODO: we should return value based on screen size here
    return convertCssUnit(value[0]);
  }
  const converted = Number.parseFloat(value.toString());
  if (Number.isNaN(converted)) {
    return value;
  }
  if (/rem/.test(value.toString())) {
    return converted * 16;
  }
  return converted;
}
